module.exports = __webpack_public_path__ + "img/viski.e1d1fa5b.jpeg";